import {
	SUCCESS_SIGNATURE_CHOSEN,
	ERROR_SIGNATURE_CHOSEN
} from '../../actionType';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

export const successGetTokenSignatureChosen = payload => ({
	type: SUCCESS_SIGNATURE_CHOSEN,
	payload
});
export const errorGetTokenSignatureChosen = payload => ({
	type: ERROR_SIGNATURE_CHOSEN,
	payload
});

export const verifySignatureChosen = signaturePLan => async dispatch => {
	const response = signaturePLan[0];

	if (response) {
		dispatch(successGetTokenSignatureChosen(response));
	} else {
		const hasError = true;
		dispatch(errorGetTokenSignatureChosen({ hasError }));
	}
};

const mapStateToProps = actionObject => {
	return actionObject;
};
const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			verifySignatureChosen
		},
		dispatch
	);

connect(mapStateToProps, mapDispatchToProps);
